import { render, staticRenderFns } from "./RespMenu.vue?vue&type=template&id=420cd1c9&scoped=true"
import script from "./RespMenu.vue?vue&type=script&lang=js"
export * from "./RespMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420cd1c9",
  null
  
)

export default component.exports